<template>
    <v-alert v-if="hasError" type="error" class="mt-2 mb-0" prominent>
        <ul class="mb-0">
            <li v-for="(validationError, index) in validationErrors" :key="index">
                <!-- eslint-disable vue/no-v-html -->
                <span v-if="isHtml" v-html="validationError" />
                <!-- eslint-enable vue/no-v-html -->
                <template v-else> {{ validationError }} </template
                ><span v-if="index + 1 !== validationErrors.length">.</span>
            </li>
        </ul>
    </v-alert>
</template>

<script>
    'use strict'

    export default {
        name: 'GlobalFormError',
        components: {},
        props: {
            error: {
                required: true
            },
            isHtml: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data: function () {
            return {}
        },
        computed: {
            hasError() {
                return !!this.error
            },
            validationErrors() {
                return this.error.split('. ')
            }
        },
        async created() {},
        methods: {}
    }
</script>

<style scoped lang="scss"></style>
